import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import PermissionCreate from 'components/Permission/Create';

const ScreenPermissionCreate = ({ classes, t }) => (
  <div className={classes.container}>
    <GridContainer justify="center">
      <GridItem xs={12} md={10}>
        <GridItem>
          <h3>{t('permissions.create.title')}</h3>
          <PermissionCreate />
        </GridItem>
      </GridItem>
    </GridContainer>
  </div>
);

ScreenPermissionCreate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(
  withStyles(validationFormsStyle)(ScreenPermissionCreate),
);
